import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericMessageService } from 'src/app/shared/services/generic-message/generic-message.service';
import { GenericMessage } from 'src/app/shared/shared-components/generic-message/generic-message.interface';

/** ConfirmationComponent */
@Component({
  selector: 'confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: [],
})
export class ConfirmationComponent implements OnInit {
  /** successMessage */
  public successMessage: GenericMessage;

  /**
   * @param ts TranslateService
   * @param router Router
   * @param genericMessageService GenericMessageService
   */
  public constructor (private ts: TranslateService, private router: Router, public genericMessageService: GenericMessageService) {}
  /** ngOnInit */
  public ngOnInit (): void {
    this.successMessage = this.genericMessageService.successMessage;
  }
}
